import OperacionesTipoForm from "./OperacionesTipoForm";
export default OperacionesTipoForm;